import { Component } from '@angular/core';
import { LegacyWidgetComponentBase } from '../widget.class';

@Component({
  selector: 'legacy-app-widget-indicators',
  templateUrl: './widget-indicators.component.html',
  styleUrls: ['./widget-indicators.component.scss'],
})
export class WidgetIndicatorsComponent extends LegacyWidgetComponentBase {}
